module.exports = __webpack_public_path__ + "images/icons/psp/boat-storage/IndoorBoat.svg";